import React from "react";
import TopBanner from "./site/TopBanner";
import Header from "./Header";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";
import ChatWidget from "./ChatWidget";

export default function Layout({ children, hideStickyCTA = false }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F5F6F8]">
      <TopBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      {!hideStickyCTA && <StickyMobileCTA />}
      <ChatWidget />
    </div>
  );
}
